import angular from 'angular';
import CardView from './messageTemplateAttachmentCardView.html';
import './MessageTemplateAttachmentCard.scss';
import { EventEmitter } from 'modules/shared/EventEmitter';
import { MessageTemplateFeatures } from '../MessageTemplateFeatures';
import { MessageTemplateButtonTypes, CallToActionTypes, HTTP_URL_REGEX, verifyActionsValueLength } from '../models/MessageTemplateButtons';
import { getDefaultImage, getInvalidImage, validateMedia } from '../MessageTemplateMediaUtils';
class MessageTemplateAttachmentCardController {
    static $inject = ['$element', '$scope', '$translate', 'AlertService'];
    constructor($element, $scope, $translate, AlertService) {
        'ngInject';
        this.$element = $element;
        this.$scope = $scope;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.$scope = {
            ...this.$scope,
            editionEnabled: false,
            previewMode: false,
            inputValue: '',
            footerValue: '',
            selectedText: {
                finalText: '',
                initialText: '',
                textSelected: '',
            },
        };
    }
    async $onInit() {
        await this.checkFeatures();
        this.defaultImage = getDefaultImage(this.type);
        if (this.type === 'image' && !!this.image) {
            await this.performImageValidation();
        }
        else if (this.type === 'video' && !!this.video) {
            await this.performVideoValidation();
        }
        if (this.onlyPreview) {
            this.formatPreviewView(this.description, this.footer);
        }
        this.$scope.inputValue = this.description || '';
        this.$scope.footerValue = this.footer || '';
        if (!this.onlyPreview) {
            if (this.isMessageTemplateButtonsEnabled) {
                this.sandboxOptions = angular.copy(this.options);
                this.sandboxButtonType = this.buttonType;
            }
            else {
                this.options = [];
                this.buttonType = MessageTemplateButtonTypes.DEFAULT;
            }
        }
    }
    async checkFeatures() {
        this.isMessageTemplateButtonsEnabled = await MessageTemplateFeatures.isMessageTemplateButtonsEnabled();
    }
    $onDestroy() {
        setTimeout(() => {
            const textareaElement = this.getTextareaElement();
            textareaElement?.removeEventListener('select', this.onSelectText.bind(this));
            textareaElement?.removeEventListener('mouseup', () => setTimeout(this.clearSelectedText.bind(this), 50));
            textareaElement?.removeEventListener('keydown', () => setTimeout(this.clearSelectedText.bind(this), 50));
        }, 1000);
    }
    async closeEditionMode() {
        this.$scope.editionEnabled = !this.$scope.editionEnabled;
        this.$scope = {
            ...this.$scope,
            editionEnabled: false,
            previewMode: false,
            inputValue: '',
            footerValue: '',
            selectedText: {
                finalText: '',
                initialText: '',
                textSelected: '',
            },
        };
        this.defaultImage = getDefaultImage(this.type);
        if (!this.isTranslation()) {
            this.image = '';
            this.document = '';
            this.video = '';
            if (this.type === 'image') {
                this.performImageValidation(true);
            }
            else if (this.type === 'video') {
                this.performVideoValidation(true);
            }
        }
        this.options = [];
        this.buttonType = MessageTemplateButtonTypes.DEFAULT;
        this.sandboxOptions = angular.copy(this.options);
        this.sandboxButtonType = this.buttonType;
    }
    enableEdition() {
        if (!this.onlyPreview) {
            this.$scope.editionEnabled = true;
        }
        this.formatPreviewView(this.description, this.footer);
    }
    getTextareaElement() {
        const element = this.$element[0];
        return element.querySelector('textarea');
    }
    getPreviewElement() {
        const element = this.$element[0];
        return element.querySelector('.mt-card__preview__text');
    }
    getFooterElement() {
        const element = this.$element[0];
        return element.querySelector('.mt-card__preview__footer');
    }
    clearSelectedTextScope() {
        this.$scope.selectedText = {
            finalText: '',
            initialText: '',
            textSelected: '',
        };
    }
    async performImageValidation(returnToDefault = false) {
        const valid = await validateMedia('image', this.image);
        if (valid) {
            this.isImageValid = true;
            return;
        }
        this.isImageValid = false;
        this.defaultImage = returnToDefault ? getDefaultImage('image') : getInvalidImage('image');
    }
    async performVideoValidation(returnToDefault = false) {
        const valid = await validateMedia('video', this.video);
        if (valid) {
            this.isVideoValid = true;
            return;
        }
        this.isVideoValid = false;
        this.defaultImage = returnToDefault ? getDefaultImage('video') : getInvalidImage('video');
    }
    async validateImage(returnToDefault = false) {
        await this.performImageValidation(returnToDefault);
    }
    async validateVideo(returnToDefault = false) {
        await this.performVideoValidation(returnToDefault);
    }
    addVariable() {
        const textareaElement = this.getTextareaElement();
        const variables = textareaElement.value.match(/{{\d{1,10}}}/gm);
        const lastVariable = variables
            ? variables
                .map(variable => parseInt(variable.replace(/[{}]/gm, '')))
                .sort((a, b) => a - b)[variables.length - 1]
            : 0;
        textareaElement.value += `{{${lastVariable + 1}}}`;
        textareaElement.focus();
        this.$scope.inputValue = textareaElement.value;
    }
    addSymbolOnText(symbol) {
        const textareaElement = this.getTextareaElement();
        if (this.$scope.selectedText.textSelected.length) {
            const { finalText, initialText, textSelected, } = this.$scope.selectedText;
            textareaElement.value =
                initialText + symbol + textSelected + symbol + finalText;
            this.clearSelectedTextScope();
            textareaElement.focus();
        }
        else {
            textareaElement.value += symbol + symbol;
            textareaElement.focus();
            const setInPosition = textareaElement.value.length - 1;
            textareaElement.setSelectionRange(setInPosition, setInPosition);
        }
    }
    onSelectText(event) {
        const { selectionStart, selectionEnd, value, } = event.target;
        const textSelected = document.getSelection().toString();
        const initialText = value.substring(0, selectionStart);
        const finalText = value.substring(selectionEnd, value.length);
        this.$scope.selectedText = { textSelected, initialText, finalText };
    }
    clearSelectedText() {
        const textSelected = document.getSelection().toString();
        if (!textSelected.length &&
            this.$scope.selectedText.textSelected.length) {
            this.clearSelectedTextScope();
        }
    }
    addListenerOnTextarea() {
        const textareaElement = this.getTextareaElement();
        textareaElement.onselect = this.onSelectText.bind(this);
        textareaElement.onmouseup = () => setTimeout(this.clearSelectedText.bind(this), 50);
        textareaElement.onkeydown = () => setTimeout(this.clearSelectedText.bind(this), 50);
    }
    applyBoldOnText() {
        this.addSymbolOnText('*');
    }
    applyItalicOnText() {
        this.addSymbolOnText('_');
    }
    applyStrikethroughOnText() {
        this.addSymbolOnText('~');
    }
    delimiterLines(line) {
        if (line) {
            const newLineArray = [];
            const splitLimits = line.match(/.{1,20}/g);
            splitLimits.map(splited => {
                if (!/\s/g.test(splited)) {
                    const newLine = `${splited}<br>`;
                    newLineArray.push(newLine);
                }
                else {
                    newLineArray.push(splited);
                }
            });
            return newLineArray.join('');
        }
        else {
            return line;
        }
    }
    formatPreviewView(message, footerMessage) {
        let value = message;
        const searchBoldText = value.match(/\*(\S(.*?\S)?)\*/gm);
        const searchItalicText = value.match(/\_(\S(.*?\S)?)\_/gm);
        const searchStrikethroughText = value.match(/\~(\S(.*?\S)?)\~/gm);
        const searchNewLines = value.match(/\\n/gm);
        const searchLineBreaks = value.match(/\n/gm);
        const replaceSymbolForTag = (value, tag) => {
            return `<${tag}>${value.substring(1, value.length - 1)}</${tag}>`;
        };
        searchBoldText &&
            searchBoldText.map(text => {
                value = value.replace(text, replaceSymbolForTag(text, 'b'));
            });
        searchItalicText &&
            searchItalicText.map(text => {
                value = value.replace(text, replaceSymbolForTag(text, 'i'));
            });
        searchStrikethroughText &&
            searchStrikethroughText.map(text => {
                value = value.replace(text, replaceSymbolForTag(text, 'strike'));
            });
        searchNewLines &&
            searchNewLines.map(lineBreak => {
                value = value.replace(lineBreak, '<br>');
            });
        searchLineBreaks &&
            searchLineBreaks.map(lineBreak => {
                value = value.replace(lineBreak, '<br>');
            });
        const splitLines = value.split('<br>');
        const delimitedLines = [];
        splitLines.map(line => {
            const newLine = this.delimiterLines(line);
            delimitedLines.push(newLine);
        });
        value = delimitedLines.join('<br>');
        setTimeout(() => {
            this.getPreviewElement().innerHTML = value;
        }, 1000);
        if (footerMessage) {
            const footer = this.delimiterLines(footerMessage);
            setTimeout(() => {
                this.getFooterElement().innerHTML = footer;
            }, 1000);
        }
    }
    async closeEditionConfirmation() {
        await this.AlertService.show({
            title: await this.$translate('attachment.closeNoSaveModal.title'),
            body: await this.$translate('attachment.closeNoSaveModal.text'),
            variant: 'warning',
            icon: 'attention',
            buttons: {
                cancel: await this.$translate('attachment.closeNoSaveModal.cancelButton'),
                confirm: await this.$translate('attachment.closeNoSaveModal.confirmButton'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: async () => { await this.closeEditionMode(); },
            },
        });
    }
    verifyIfButtonsIsInvalid() {
        if (this.sandboxButtonType === MessageTemplateButtonTypes.DEFAULT) {
            return false;
        }
        const valueArr = this.sandboxOptions.map((item) => item.inputText) || [];
        const isDuplicate = valueArr.some((item, idx) => {
            return valueArr.indexOf(item) !== idx;
        });
        const hasInvalidButtonName = valueArr.find((item) => item?.length === 0 || item?.length > 20);
        if (this.sandboxButtonType === MessageTemplateButtonTypes.CALL_TO_ACTION) {
            const callToActionisValid = this.sandboxOptions.find(item => (item.url === '' && item.phone_number === '') ||
                (verifyActionsValueLength(item.url, true) || verifyActionsValueLength(item.phone_number, false)) ||
                (item.type === CallToActionTypes.URL &&
                    !new RegExp(HTTP_URL_REGEX).test(item.url)));
            if (callToActionisValid) {
                return true;
            }
        }
        return (isDuplicate || hasInvalidButtonName !== undefined);
    }
    save() {
        if (this.type === 'image' && this.image) {
            this.validateImage();
        }
        else if (this.type === 'video' && this.video) {
            this.validateVideo();
        }
        this.$scope.editionEnabled = false;
        this.description = this.$scope.inputValue;
        const content = {
            imageLink: this.isImageValid ? this.image : '',
            documentLink: this.document,
            videoLink: this.isVideoValid ? this.video : '',
            description: this.$scope.inputValue,
            footer: this.$scope.footerValue,
        };
        const buttonsArray = [];
        if (this.isMessageTemplateButtonsEnabled) {
            this.options = angular.copy(this.sandboxOptions);
            this.buttonType = this.sandboxButtonType;
            if (this.buttonType !== MessageTemplateButtonTypes.DEFAULT) {
                this.options.map(button => {
                    if (button.type === CallToActionTypes.PHONE_NUMBER) {
                        buttonsArray.push({
                            type: button.type.toUpperCase(),
                            text: button.text,
                            phone_number: button.phone_number,
                        });
                    }
                    else if (button.type === CallToActionTypes.URL) {
                        buttonsArray.push({
                            type: button.type.toUpperCase(),
                            text: button.text,
                            url: button.url,
                        });
                    }
                    else {
                        buttonsArray.push({
                            type: this.buttonType.toUpperCase(),
                            text: button.text,
                        });
                    }
                });
            }
        }
        this.onConfirm(EventEmitter({ content, buttonsArray }));
    }
}
MessageTemplateAttachmentCardController.$inject = ['$element', '$scope', '$translate', 'AlertService'];
export const MessageTemplateAttachmentCardComponent = {
    template: CardView,
    controller: MessageTemplateAttachmentCardController,
    controllerAs: '$ctrl',
    bindings: {
        onConfirm: '&?',
        type: '@',
        image: '=?',
        document: '=?',
        video: '=?',
        isTranslation: '&?',
        isImageValid: '=?',
        isVideoValid: '=?',
        onlyPreview: '=?',
        description: '@?',
        footer: '@?',
        buttonType: '=?',
        options: '=?',
        thereTranslations: '&?',
    },
};
